import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalWithSidebar } from '@livable/saas-react-components';
import { OverviewTab } from './OverviewTab';
import { MoveOutTab } from 'src/components/resident/ResidentModal/MoveOutTab';
import ActivityLogTab from './ActivityLogTab';
// import MessageTab from './MessageTab';
// import PostChargeTab from './PostChargeTab';
import SolutionTab from './SolutionTab';
import { NotesTab } from './NotesTab';
import OuterFooter from './OuterFooter';
import { RentDetailsTab } from './RentDetailsTab';
import { ResidentDetailsTab } from './ResidentDetailsTab';
import { useStore } from 'src/stores';
const ResidentModal = observer(props => {
  var _store$homeDashboardS, _store$homeDashboardS2;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const accountId = props.accountId,
    activeTab = props.activeTab,
    dataNavigation = props.dataNavigation,
    handleClose = props.handleClose,
    handleNavigation = props.handleNavigation,
    handleOpen = props.handleOpen,
    isOpen = props.isOpen,
    livableTab = props.livableTab,
    noOuterFooter = props.noOuterFooter,
    propertyId = props.propertyId,
    residencyId = props.residencyId,
    setActiveTab = props.setActiveTab,
    unitName = props.unitName,
    parentToggleRefreshCallback = props.parentToggleRefreshCallback;
  const residencyOverview = store.residencies.residencyOverview;
  const name = unitName || residencyOverview.unitName;
  const handleTabChange = (e, newValue) => {
    setActiveTab(newValue);
  };
  const tabs = [{
    label: t('unit_modal.overview'),
    name: 'overview'
  },
  // {
  //   label: t('unit_modal.personal_details'),
  //   name: 'personal-details',
  //   topDivider: true,
  // },
  {
    label: t('unit_modal.livable_solution'),
    name: 'livable-solution'
  },
  // {
  //   label: t('unit_modal.rent_details'),
  //   name: 'rent-details',
  // },
  {
    label: t('unit_modal.schedule_move-out'),
    name: 'move-out',
    topDivider: true
  }
  // {
  //   label: 'Post charge/credit',
  //   name: 'post-charge',
  // },
  // {
  //   label: 'Send a message',
  //   name: 'message',
  // },
  // {
  //   label: t('unit_modal.notes'),
  //   name: 'notes',
  //   topDivider: true,
  // },
  ];
  if (store.account.featureFlagsStore.getIsActivityLogsEnabled) {
    //   tabs.push({
    //     label: t('unit_modal.activity_log'),
    //     name: 'activity-log',
    //   });
  }
  if (localStorage.getItem('livable_demo_mode') !== 'Demo') {
    tabs.splice(1, 0, {
      label: t('unit_modal.personal_details'),
      name: 'personal-details',
      topDivider: true
    });
    tabs.splice(3, 0, {
      label: t('unit_modal.rent_details'),
      name: 'rent-details'
    });
    tabs.push({
      label: t('unit_modal.notes'),
      name: 'notes',
      topDivider: true
    });
  }
  return /*#__PURE__*/React.createElement(ModalWithSidebar, {
    tabs: tabs,
    subTitle: (_store$homeDashboardS = store.homeDashboardStore.getPropertyById(propertyId)) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.propertyInformation) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.address) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.addressString,
    isOpen: isOpen,
    handleOpen: handleOpen,
    handleClose: handleClose,
    selectedTab: activeTab,
    handleTabChange: handleTabChange,
    noInnerFooter: true,
    outerFooter: !noOuterFooter && dataNavigation && dataNavigation.length > 0 && /*#__PURE__*/React.createElement(OuterFooter, {
      dataNavigation: dataNavigation,
      handleNavigation: handleNavigation
    }),
    title: "".concat(t('general.unit'), " ").concat(name)
  }, activeTab === 'overview' && /*#__PURE__*/React.createElement(OverviewTab, {
    isOpen: isOpen,
    residencyId: residencyId,
    accountId: accountId,
    propertyId: propertyId,
    changeGlobalTab: setActiveTab,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  }), activeTab === 'personal-details' && /*#__PURE__*/React.createElement(ResidentDetailsTab, {
    accountId: accountId,
    residencyId: residencyId,
    activeResidency: (_store$homeDashboardS2 = store.homeDashboardStore.getPropertyById(propertyId)) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.propertyInformation) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.address) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.addressString,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  }), (activeTab === 'livable-solution' || activeTab === 'billing-settings') && /*#__PURE__*/React.createElement(SolutionTab, {
    isOpen: isOpen,
    accountId: accountId,
    livableTab: livableTab,
    propertyId: propertyId,
    residencyId: residencyId,
    handleGlobalTabChange: handleTabChange,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  }), activeTab === 'rent-details' && /*#__PURE__*/React.createElement(RentDetailsTab, {
    residencyId: residencyId,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  }), activeTab === 'move-out' && /*#__PURE__*/React.createElement(MoveOutTab, {
    accountId: accountId,
    propertyId: propertyId,
    residencyId: residencyId,
    unitName: unitName,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  }), activeTab === 'notes' && /*#__PURE__*/React.createElement(NotesTab, {
    residencyId: residencyId
  }), activeTab === 'activity-log' && /*#__PURE__*/React.createElement(ActivityLogTab, {
    residencyId: residencyId
  }));
});
export default ResidentModal;